<template>
    <div class="statistics">
      <div class="cut"><button>切换至地图模式</button></div>
      <div class="content_top">
        <!--实时告警-->
        <div :class='["warning_time","light_border"]'>
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <p>实时告警</p>
          <div v-for="(item,index) in warning" class="warning_msg">
            <div  v-bind:style="[{background:'url('+item.pic+') no-repeat center center'}]"></div>
            <p><span>{{item.time}}</span>条</p>
          </div>
        </div>
        <!--充电站统计-->
        <div :class='["recharge_statistics","light_border"]'>
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="charging_station">
            <div v-for="(item,index) in station"  class="charging_station_box">
              <div  v-bind:style="[{background:'url('+item.icon+') no-repeat center center'}]"></div>
              <div>
                <p v-bind:style="[{color:item.color}]">{{item.num}}</p>
                <span>{{item.name}}</span>
              </div>
            </div>

          </div>
          <div v-for="(item,index) in charging"  class="charging_msg">
            <p>充电站<span>{{item.altogether}}</span></p>
            <p>运营中充电站<span>{{item.operating}}</span></p>
            <p>建设中充电站<span>{{item.construction}}</span></p>
          </div>
        </div>
        <!--充电桩充电情况-->
        <div :class='["charger_statistics","light_border"]'>
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="charger_box">
            <ul>
              <li  v-for="(item,index) in charger" ><div>{{item.title}} <span v-bind:style="[{color:item.hue}]">{{item.num}}</span><span>个</span></div></li>
            </ul>
          </div>
        </div>
      </div>
      <div class="content_bottom">
        <!--在线人数统计-->
        <div :class='["content_left","light_border"]'>
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
            <div class="people_num">
              <p>在线人数统计</p>
              <div class="attention">
                <div  v-for="(item,index) in attention"><div >{{item.att_title}}</div><div>{{item.att_num}}</div></div>
              </div>
            </div>
        </div>
        <div class="content_right">
          <!--充电数据统计-->
          <div :class='["charging_data","light_border"]'>
            <div class="border_top_left"></div>
            <div class="border_top_right"></div>
            <div class="border_bottom_left"></div>
            <div class="border_bottom_right"></div>
            <div class="charging_box">
              <div class="charging_title">
                <span>充电数据统计</span>
                <button>进入充电桩</button>
              </div>

            </div>
          </div>
          <div class="chart_box">
            <div :class='["chart_part","light_border"]' style="margin:0px 10px 10px 0px">
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="chart_content">
                <div class="chart_title">
                  <span>使用率统计</span>
                </div>
              </div>
            </div>
            <div :class='["chart_part","light_border"]'>
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="chart_content">
                <div class="chart_title">
                  <span>功率</span>
                </div>
              </div>
            </div>
            <div :class='["chart_part","light_border"]' style="margin:0px 10px 10px 0px">
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="chart_content">
                <div class="chart_title">
                  <button class="income_btn focus">每日用户数</button>
                  <button class="income_btn">每月用户数</button>
                  <button class="income_btn">每季用户数</button>
                </div>
              </div>
            </div>
            <div :class='["chart_part","light_border"]'>
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="chart_content">
                <div class="chart_title">
                  <button class="income_btn focus">每日收益</button>
                  <button class="income_btn">每月收益</button>
                  <button class="income_btn">每季收益</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
    export default {
        name: "statistics",
      data() {
        return {
          warning:[
            {pic: "/static/img/waring.png", time: "2"},
          ],
          charging: [
            {altogether:"65687",operating:"1125",construction:"566"}
          ],
          station: [
            {
              icon:"/static/img/station_pic1.png",
              num:"266",
              name:"充电总量（度）",
              color:"#ffa200"
            },{
              icon:"/static/img/station_pic2.png",
              num:"92326",
              name:"充电总时长（分钟）",
              color:"#00fafe"
            },{
              icon:"/static/img/station_pic3.png",
              num:"15623",
              name:"充电总次数（次）",
              color:"#00fafe"
            },
          ],
          charger: [
            { title:"充电", num:"10",hue:"#00fafe" },
            { title:"空闲", num:"55",hue:"#00fafe"  },
            { title:"充完未拔枪", num:"4",hue:"#00fafe"  },
            { title:"维护", num:"3",hue:"#fda101" },
            { title:"离线", num:"8",hue:"#d80051" },
            { title:"插枪未充电", num:"2",hue:"#00fafe"},
          ],
          attention: [
            {att_title:"新用户：",att_num:"18888人"},
            {att_title:"会员用户：",att_num:"36598人"},
            {att_title:"微信关注：",att_num:"96586人"},
          ]
        }
      },
      methods:{
        InitLeftMenu: function () {
          this.$emit('getMessage', '7', '1');
        },
      },
      created(){
        this.InitLeftMenu()
      },
      mounted() {
        $(function () {
          $('.income_btn').click(function () {
            $(this).addClass('focus').siblings().removeClass('focus');
          });
        });
      }
    }
</script>

<style scoped>
  .statistics{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .cut{
    width: 100%;
    height: 20px;
    text-align: right;
  }
  .cut>button{
    height: 20px;
    color: #01cbc9;
    font-size: 12px;
    background: transparent;
    border: transparent;
    outline: transparent;
    text-align: right;
    text-decoration: underline;
  }
  .content_top{
    width: 100%;
    height: 14%;
    min-height: 120px;
    padding: 10px 0px;
    box-sizing: border-box;
  }
  .warning_time{
    width: 18%;
    height: 100%;
    margin-right: 5px;
    box-sizing: border-box;
    position: relative;
    float: left;
    background: #0b2f54;
    text-align: center;
  }
  .warning_time>p{
    color: #00f0ff;
    line-height: 40px;
    margin: 0px;
  }

  .recharge_statistics{
    width: 52%;
    height: 100%;
    margin: 0px 5px;
    box-sizing: border-box;
    position: relative;
    float: left;
    background: #0b2f54;
  }
  .charger_statistics{
    width: calc(30% - 20px);
    height: 100%;
    margin-left: 5px;
    box-sizing: border-box;
    position: relative;
    float: left;
    background: #0b2f54;
  }
  .content_bottom{
    width: 100%;
    height: calc(86% - 30px);
  }
  .content_left{
    width: 18%;
    height: 100%;
    margin-right: 5px;
    padding: 20px;
    box-sizing: border-box;
    position: relative;
    float: left;
    background: #0b2f54;
  }
  .people_num{
    width: 100%;
    height: 100%;
  }
  .people_num>p{
    width: 100%;
    color: #00fafe;
    text-align: center;
  }
  .attention{
    width: 100%;
    height: 180px;
    color: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .attention>div{
    width: 100%;
  }
  .attention>div>div:nth-child(1){
    width: 50%;
    text-align: right;
    float: left;
    line-height: 30px;
  }
  .attention>div>div:nth-child(2){
    width: 50%;
    color: #00fafe;
    float: left;
    line-height: 30px;
  }
  .content_right{
    width: calc(82% - 10px);
    height: 100%;
    margin-left: 5px;
    box-sizing: border-box;
    float: left;
  }
  .charging_data{
    width: calc(100% - 3px);
    height: 40%;
    margin-bottom: 10px;
    position: relative;
    background: #0b2f54;
  }
  .charging_box{
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
  }
  .charging_title{
    width: 100%;
  }
  .charging_title>span{
    color: #00fafe;
  }
  .charging_title>button{
    background: #217fdf;
    border: transparent;
    outline: transparent;
    padding: 5px 10px;
    color: #FFFFFF;
    border-radius: 4px;
    margin-left: 10px;
  }
  .charging_title>button:active{
    background: #1a75d2;
  }
  .chart_box{
    width: 100%;
    height: calc(60% - 10px);
  }
  .chart_part{
    width: calc(50% - 8px);
    height: calc(50% - 8px);
    position: relative;
    float: left;
    background: #0b2f54;
  }
  .warning_msg{
    width: 100%;
    color: #d8271c;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  .warning_msg>div{
    width: 24px;
    height: 22px;
    margin-bottom: 5px;
  }
  .charging_station{
    width: calc(100% - 200px);
    height: 100%;
    position: absolute;
    padding: 20px;
  }
  .charging_station_box{
    height: calc(100% - 40px);
    float: left;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .charging_station_box>div:nth-child(1){
    width: 30px;
    height: 30px;
  }
  .charging_station_box>div:nth-child(2){
    margin: 0px 20px;
  }
  .charging_station_box>div>p{
    margin: 0px;
    font-family: '$number';
    font-size: 26px;
    line-height: 30px;
  }
  .charging_station_box>div>span{
    color: #c9def6;
    font-size: 14px;
  }
  .charging_msg{
    width: 200px;
    height: calc(100% - 20px);
    position: absolute;
    right: 0px;
    border-left: 1px solid #FFFFFF;
    margin: 10px 0px;
    border-image: -webkit-linear-gradient(#10345a,#FFFFFF,#10345a) 3 10;
    border-image: -moz-linear-gradient(#10345a,#FFFFFF,#10345a) 3 10;
    border-image: linear-gradient(#10345a,#FFFFFF,#10345a) 3 10;
  }
  .charging_msg>p{
    padding: 0px 20px ;
    margin: 0px;
    color: #FFFFFF;
  }
  .charging_msg>p>span{
    color: #00fafe;
    float: right;
  }
  .charger_box{
    width: 100%;
    height: 100%;
    padding: 10px 30px;
    box-sizing: border-box;
  }
  .charger_box>ul{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .charger_box>ul>li{
    width: 30%;
    color: #FFFFFF;
  }
  .charger_box>ul>li>div>span:nth-child(1){
    font-family: '$number';
    padding-left: 10px;
  }
  .charger_box>ul>li>div>span:nth-child(2){
    font-size: 12px;
    color: #c9def6;
  }
  .chart_content{
    width: 100%;
    height: 100%;
    padding: 10px 20px;
    box-sizing: border-box;
  }

  .chart_title>span{
    color: #00fafe;
  }

  .income_btn{
    background: transparent;
    border: transparent;
    outline: transparent;
    color: #95bee5;
    margin-right: 20px;
  }
  .focus{
    color: #00fafe;
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/8_chargingpile/statistics.vue